<template>
  <div
    v-touch.long="() => emit('long-press')"
    class="group relative flex cursor-pointer items-center rounded-8 p-1 hover:bg-bg-base-bg3 active:bg-surf-neut-soft-pres"
    :data-gallery-media-anchor="!showKebab ? anchorId : undefined"
    data-test="chat-gallery-file-item"
    @click="emit('open')"
    @contextmenu.prevent="emit('contextmenu', $event)"
  >
    <div class="pointer-events-none size-[44px] shrink-0">
      <div
        v-if="isVoice"
        class="flex size-full items-center justify-center rounded-8 bg-surf-neut-soft-def text-fg-base-fg3"
        data-test="chat-gallery-voice-file-icon"
      >
        <wui-icon
          name="micM"
          class="size-6!"
        />
      </div>
      <file-icon
        v-else-if="fileName"
        :mime="mime"
        :cookie="cookie"
        :name="fileName"
        :open-preview-on-click="false"
        :bordered="false"
        rounded-class="rounded-4"
      />
    </div>

    <div class="flex min-w-0 flex-1 flex-col gap-0.5 py-0.5 pl-2">
      <p
        class="line-clamp-1 break-all text-body-m-14-20 text-fg-base-fg3"
        :title="title"
      >
        {{ title }}
      </p>
      <p
        v-if="subtitle"
        class="truncate text-label-r-13-18 text-fg-base-fg22"
      >
        {{ subtitle }}
      </p>
    </div>

    <div
      v-if="showKebab"
      class="ml-1 hidden shrink-0 group-hover:block"
      :class="{ '!block': isMenuActive }"
    >
      <wui-btn
        icon
        variant="neut"
        state="alpha"
        :size="32"
        prepend-icon="kebabVerticalM"
        :data-gallery-media-anchor="anchorId"
        data-test="chat-gallery-file-menu"
        :aria-label="$t('common.more')"
        @click.stop="emit('open-menu', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { WuiBtn, WuiIcon } from '@wui/common-library'

import { FileIcon } from '@/entities/chat-event-file'

import { vTouch } from '@/shared/directives/v-touch'

withDefaults(defineProps<{
  title: string
  subtitle?: string
  mime?: string
  cookie?: string
  fileName?: string
  isVoice?: boolean
  showKebab?: boolean
  isMenuActive?: boolean
  anchorId?: string
}>(), {
  subtitle: '',
  mime: '',
  cookie: '',
  fileName: '',
  isVoice: false,
  showKebab: false,
  isMenuActive: false,
  anchorId: '',
})

const emit = defineEmits<{
  (event: 'open'): void
  (event: 'open-menu', mouseEvent: Event): void
  (event: 'contextmenu', mouseEvent: MouseEvent): void
  (event: 'long-press'): void
}>()
</script>
